/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LiquidationRepay,
  LiquidationRepayInterface,
} from "../LiquidationRepay";

const _abi = [
  {
    inputs: [],
    name: "RepayFailed",
    type: "error",
  },
];

export class LiquidationRepay__factory {
  static readonly abi = _abi;
  static createInterface(): LiquidationRepayInterface {
    return new utils.Interface(_abi) as LiquidationRepayInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LiquidationRepay {
    return new Contract(address, _abi, signerOrProvider) as LiquidationRepay;
  }
}
